const CURRENT_MEMBERSHIP_KEY = "currentMembership";

export const saveCurrentMembership = (membership) => {
  try {
    sessionStorage.setItem(CURRENT_MEMBERSHIP_KEY, JSON.stringify(membership));
  } catch (e) {
    console.log(e);
    return false;
  }

  return true;
};

export const getCurrentMembership = () => {
  let currentMembership;
  try {
    currentMembership = JSON.parse(
      sessionStorage.getItem(CURRENT_MEMBERSHIP_KEY)
    );
  } catch (e) {
    console.log(e);
    return null;
  }

  return currentMembership;
};
